module.exports = __webpack_public_path__ + "img/shoals-logo.28b7ff6a.jpg";